import { User, Profile, InvoiceAddress } from '@/models/User';
import { Token } from '@atabix/core';
import client from '@/support/Client';

export class Contact extends User {
  protected $name: string = 'Contact';
  protected $endpoint: string = '/users';

  protected filters: object = {
    role: 'contact',
  };

  protected $fillable: string[] = [
    'first_name',
    'middle_name',
    'last_name',
    'email',
    'language',
    'delivery_at',
    'quiz_completed',
    'pickup_at',
    'profile',
    'images',
    'invoice_address',
    'my_referral_code'
  ];

  public delivery_at?: any;
  public quiz_completed?: boolean;
  public pickup_at?: any;
  public images?: string[];

  public get answers() {
    if (this.profile && this.profile.answers) {
      return this.profile.answers;
    }
    return '';
  }

  public set answers(answers: any) {
    (this.profile as any).answers = answers;
  }

  public get invoice_address(): InvoiceAddress | null {
    if (this.profile && this.profile.invoice_address) {
      return this.profile.invoice_address;
    }
    return null;
  }

  public get address_addition(): string | null {
    if (this.profile && this.profile.address_addition) {
      return this.profile.address_addition;
    }
    return null;
  }

  public set address_addition(address_addition: string | null) {
    (this.profile as any).address_addition = address_addition;
  }

  public get address_additional_info(): string | null {
    if (this.profile && this.profile.address_additional_info) {
      return this.profile.address_additional_info;
    }
    return null;
  }

  public set address_additional_info(address_addition: string | null) {
    (this.profile as any).address_addition = address_addition;
  }

  public get has_different_invoice_address(): boolean {
    if (this.profile && this.profile.has_different_invoice_address) {
      return this.profile.has_different_invoice_address;
    }
    return false;
  }

  public set has_different_invoice_address(has_different_invoice_address: boolean) {
    (this.profile as any).has_different_invoice_address = has_different_invoice_address;
  }

  public get address_number(): string | null {
    if (this.profile && this.profile.address_number) {
      return this.profile.address_number;
    }
    return null;
  }

  public set address_number(address_number: string | null) {
    (this.profile as any).address_number = address_number;
  }

  public get birthday_at(): string | null {
    if (this.profile && this.profile.birthday_at) {
      return this.profile.birthday_at;
    }
    return null;
  }

  public set birthday_at(birthday_at: string | null) {
    (this.profile as any).birthday_at = birthday_at;
  }

  public get repeat_intention_date(): string | null {
    if (this.profile && this.profile.repeat_intention_date) {
      return this.profile.repeat_intention_date;
    }
    return null;
  }

  public set repeat_intention_date(repeat_intention_date: string | null) {
    (this.profile as any).repeat_intention_date = repeat_intention_date;
  }

  public get repeat_next_order(): string | null {
    if (this.profile && this.profile.repeat_next_order) {
      return this.profile.repeat_next_order;
    }
    return null;
  }

  public set repeat_next_order(repeat_next_order: string | null) {
    (this.profile as any).repeat_next_order = repeat_next_order;
  }

  public get repeat_frequency(): string | null {
    if (this.profile && this.profile.repeat_frequency) {
      return this.profile.repeat_frequency;
    }
    return null;
  }

  public set repeat_frequency(repeat_frequency: string | null) {
    (this.profile as any).repeat_frequency = repeat_frequency;
  }

  public get city(): string | null {
    if (this.profile && this.profile.city) {
      return this.profile.city;
    }
    return null;
  }

  public set city(city: string | null) {
    (this.profile as any).city = city;
  }

  public get country(): string | null {
    if (this.profile && this.profile.country) {
      return this.profile.country;
    }
    return null;
  }

  public set country(country: string | null) {
    (this.profile as any).country = country;
  }

  public get phone(): string | '' {
    if (this.profile && this.profile.phone) {
      return this.profile.phone;
    }
    return '';
  }

  public get user_id(): string {
    // @ts-ignore
    if (this.profile && this.profile.user_id) {
      // @ts-ignore
      return this.profile.user_id;
    }

    return '';
  }

  public get age(): string {
    if (this.profile && this.profile.age) {
      return this.profile.age;
    }

    return '';
  }

  public set phone(phone: string | '') {
    (this.profile as any).phone = phone;
  }

  public get street(): string | null {
    if (this.profile && this.profile.street) {
      return this.profile.street;
    }
    return null;
  }

  public set street(street: string | null) {
    (this.profile as any).street = street;
  }

  public get company(): string | '' {
    if (this.profile && this.profile.company) {
      return this.profile.company;
    }
    return '';
  }

  public set company(company: string | '') {
    (this.profile as any).company = company;
  }

  public get zip_code(): string | null {
    if (this.profile && this.profile.zip_code) {
      return this.profile.zip_code;
    }
    return null;
  }

  public set zip_code(zip_code: string | null) {
    (this.profile as any).zip_code = zip_code;
  }

  public get zoho_contact_id(): string | null {
    if (this.profile && this.profile.zoho_contact_id) {
      return this.profile.zoho_contact_id;
    }
    return null;
  }

  public createPaazlOrder(leadId: string, payload: object) {
    const endpoint = `${this.$endpoint}/${leadId}/create-paazl-order?with[]=profile&with[]=paazl`;
    return client('post', endpoint, payload);
  }
}
